import { ActionList, Button, EmptyState, InlineStack, Modal, Popover, Tooltip, Tabs, BlockStack, Divider, Banner, Text, ComplexAction } from '@shopify/polaris';
import { MobileVerticalDotsMajor, ViewMinor } from '@shopify/polaris-icons';
import React, { useCallback, useEffect, useState } from 'react';
import { DI, DIProps } from '../../../../Core';
import AmazonPreview from './AmazonPreview';
import NoResultsFound from '../../../../Asests/Images/NoResultsFound.png';
import { getStatusFormatted, DataToSend } from '../Utilities/Helper';
import { previewModalI, preview_modal_dataI } from '../Utilities/Interface';
import { modalLoader } from '../skeleton/TableSkeleton';
import TabularPreview from './TabularPreview';
import { previewModalTabs } from '../Utilities/Constants';
import { useTranslation } from 'react-i18next';
import { isAdminLoggedIn } from '../../Panel/index';
interface Props extends DIProps {
    bulkedit?: boolean;
    row: any
    setactiontype: (data: any) => void
    setsyncModal: (data: boolean) => void
    syncModal: boolean;
    // setLDModal: React.Dispatch<React.SetStateAction<{ open: boolean, selectedRows: string[], selectedRowsChild: string[] }>>
}

const StatusWiseAction = (props: Props) => {
    const { t } = useTranslation();
    const { row, setactiontype, setsyncModal, syncModal } = props;

    const [rowWiseAction, setrowWiseAction] = useState<string>('');
    const [options, setoptions] = useState<any>([]);
    const [popoverActive, setPopoverActive] = useState(false);
    const [previewModal, setPreviewModal] = useState<previewModalI>({
        open: false,
        loading: false,
        btnLoading: false,
        msg: ""
    });
    const togglePopoverActive = useCallback(() => setPopoverActive((popoverActive) => !popoverActive), []);
    const [previewModalData, setPreviewModalData] = useState<preview_modal_dataI>({
        mandatory_attr: {},
        optional_attr: {},
        offerId: "",
    });
    const [variantsArr, setVariantsArr] = useState<any>([]);
    const [selectedVariant, setSelectedVariant] = useState<string>('');
    const [tabSelected, setTabSelected] = useState<number>(0);
    const [tabularData, setTabularData] = useState<preview_modal_dataI>({
        mandatory_attr: {},
        optional_attr: {},
        offerId: "",
    });
    const handleTabChange = useCallback((selectedTabIndex: number) => setTabSelected(selectedTabIndex), []);

    useEffect(() => {
        if (rowWiseAction === "Old Edit Product") {
            props.history(`../product/${row['container_id']}`, {
                state: {
                    status: row,
                    source_product_id: row.source_product_id ?? row.container_id ?? '',
                    errorExists: row?.has_flags?.has_error,
                    progressExists: row?.has_flags?.has_progress,
                    warningExists: row?.has_flags?.has_warning,
                }
            });
        }
        else if (rowWiseAction === "Edit Product") {
            props.history(`../product/new/${row['container_id']}`, {
                state: {
                    status: row,
                    source_product_id: row.source_product_id ?? row.container_id ?? '',
                    errorExists: row?.has_flags?.has_error,
                    progressExists: row?.has_flags?.has_progress,
                    warningExists: row?.has_flags?.has_warning,
                }
            });
        }
        else if (rowWiseAction != '') {
            switch (rowWiseAction) {
                case 'Sync Product':
                    setactiontype({
                        title: t('Sync Product'),
                        key: "Sync Product",
                        source_product_id: row.source_product_id,
                        description: t('Do you want to upload the selected product(s) ?'),
                        actionName: t('Proceed'),
                    });
                    setsyncModal(true);
                    break;
                case 'Sync Inventory':
                    setactiontype({
                        title: t('Sync Inventory'),
                        key: 'Sync Inventory',
                        source_product_id: row.source_product_id,
                        description: t('Do you want to proceed with syncing inventory of selected product(s) ?'),
                        actionName: t('Start'),
                    });
                    setsyncModal(true);
                    break;

                case 'Amazon Lookup':
                    setactiontype({
                        title: t('Amazon Lookup'),
                        key: 'Amazon Lookup',
                        source_product_id: row.source_product_id,
                        description: t("You can choose a number of products you want Amazon Lookup to run for and update your listings that are “Not Listed: Offer”."),
                        actionName: t('Start'),
                    });
                    setsyncModal(true);
                    break;

                case 'Sync price':
                    setactiontype({
                        title: t('Sync Price'),
                        key: 'Sync Price',
                        source_product_id: row.source_product_id,
                        description: t('Do you want to proceed with syncing price of selected product(s) ?'),
                        actionName: t('Start'),
                    });
                    setsyncModal(true);
                    break;

                case 'Sync Image':
                    setactiontype({
                        title: t('Sync Image'),
                        key: 'Sync Image',
                        source_product_id: row.source_product_id,
                        description: t('Do you want to proceed with syncing image of selected product(s) ?'),
                        actionName: t('Start'),
                    });
                    setsyncModal(true);
                    break;

                case 'Delete Product':
                    setactiontype({
                        title: t('Delete Product'),
                        key: 'Delete Product',
                        source_product_id: row.source_product_id,
                        description: t('Do you want to delete the selected product(s) ?'),
                        actionName: t('Start'),
                    });
                    setsyncModal(true);
                    break;
            }
        }
    }, [rowWiseAction]);

    const getShopID = () => {
        return {
            sourceShopID: props.redux.current.source._id,
            targetShopID: props.redux.current.target._id,
        };
    };

    // const getFilteredOptions = (arr: any, row: any) => {
    //     const isAIUpdated = row?.items?.[0]?.ai_updated_product;
    //     const isAdmin = isAdminLoggedIn();

    //     if (isAIUpdated) {
    //         arr.push({ content: t('Edit Product'), onAction: () => setrowWiseAction("Edit Product") });
    //     } else {
    //         arr.push({ content: t('Old Edit Product'), onAction: () => setrowWiseAction("Old Edit Product") });
    //         if (isAdmin) {
    //             arr.push({ content: t('Edit Product'), onAction: () => setrowWiseAction("Edit Product") });
    //         }
    //     }

    //     return arr;
    // };

    //working code
    // const getFilteredOptions = (arr: any, row: any) => {
    //     const isAIUpdated = row?.items?.[0]?.ai_updated_product;
    //     const isAdmin = isAdminLoggedIn();

    //     const options = isAIUpdated
    //         ? [{ content: t('Edit Product'), onAction: () => setrowWiseAction("Edit Product") }]
    //         : [{ content: t('Old Edit Product'), onAction: () => setrowWiseAction("Old Edit Product") }];

    //     if (isAdmin && !isAIUpdated) {
    //         options.push({ content: t('Edit Product'), onAction: () => setrowWiseAction("Edit Product") });
    //     }

    //     return [...arr, ...options];
    // };

    const getFilteredOptions = (arr: any, row: any) => {
        const isAIUpdated = row?.items?.[0]?.ai_updated_product;
        const isAdmin = isAdminLoggedIn();

        const options = [];

        if (isAdmin && !isAIUpdated) {
            options.push(
                { content: t('Old Edit Product'), onAction: () => setrowWiseAction("Old Edit Product") },
                { content: t('Edit Product'), onAction: () => setrowWiseAction("Edit Product") }
            );
        } else {
            options.push({ content: t('Edit Product'), onAction: () => setrowWiseAction("Edit Product") });
        }

        return [...arr, ...options];
    };

    useEffect(() => {
        setrowWiseAction('');
        let option = [
            { content: t('Amazon Lookup'), onAction: () => setrowWiseAction("Amazon Lookup") },
        ]
        option = getFilteredOptions(option, row);

        let status = getStatusFormatted(row, getShopID())?.label;

        if (status == 'Error') {
            let tempData: any = [];

            let tempRow = JSON.parse(JSON.stringify(row));
            tempRow.items.map((data: any) => {
                delete data['error'];
                tempData.push(data);
            });
            let Newrow = { ...tempRow, items: tempData };
            status = getStatusFormatted(Newrow, getShopID())?.label;
        }

        switch (status) {
            case 'Inactive':
                option = [
                    { content: t('Amazon Lookup'), onAction: () => setrowWiseAction("Amazon Lookup") },
                    { content: t('Sync Inventory'), onAction: () => setrowWiseAction("Sync Inventory") },
                    { content: t('Sync Price'), onAction: () => setrowWiseAction("Sync price") },
                    { content: t('Sync Image'), onAction: () => setrowWiseAction("Sync Image") },
                    { content: t('Sync Product'), onAction: () => setrowWiseAction("Sync Product") },
                    { content: t('Delete Product'), onAction: () => setrowWiseAction("Delete Product") },
                ];
                option = getFilteredOptions(option, row);
                break;
            case 'Active':
                option = [
                    { content: t('Amazon Lookup'), onAction: () => setrowWiseAction("Amazon Lookup") },
                    { content: t('Sync Inventory'), onAction: () => setrowWiseAction("Sync Inventory") },
                    { content: t('Sync Price'), onAction: () => setrowWiseAction("Sync price") },
                    { content: t('Sync Image '), onAction: () => setrowWiseAction("Sync Image") },
                    { content: t('Sync Product'), onAction: () => setrowWiseAction("Sync Product") },
                    { content: t('Delete Product'), onAction: () => setrowWiseAction("Delete Product") },
                ];
                option = getFilteredOptions(option, row);

                break;
            case 'Incomplete':
                option = [
                    { content: t('Amazon Lookup'), onAction: () => setrowWiseAction("Amazon Lookup") },
                    { content: t('Sync Inventory'), onAction: () => setrowWiseAction("Sync Inventory") },
                    { content: t('Sync Price'), onAction: () => setrowWiseAction('Sync price') },
                    { content: t('Sync Image '), onAction: () => setrowWiseAction("Sync Image") },
                    { content: t('Sync Product'), onAction: () => setrowWiseAction("Sync Product") },
                    { content: t('Delete Product'), onAction: () => setrowWiseAction("Delete Product") },
                ];
                option = getFilteredOptions(option, row);
                break;
            case 'Not Listed':
                option = [
                    { content: t('Amazon Lookup'), onAction: () => setrowWiseAction("Amazon Lookup") },
                ];
                option = getFilteredOptions(option, row);
                break;
            default:
                option = [
                    { content: t('Amazon Lookup'), onAction: () => setrowWiseAction("Amazon Lookup") },
                ];
                option = getFilteredOptions(option, row);
        }
        setoptions(option);
    }, [props, rowWiseAction]);

    const getPreview = async (sourceProductId?: string) => {
        setPreviewModal({ ...previewModal, open: true, loading: true, btnLoading: false })
        let tempData: any = { ...previewModalData };
        let tempTabularData: any = { ...tabularData }
        let payload: any = {
            ...DataToSend(props),
            "source_product_ids": sourceProductId ? [sourceProductId] : [row?.source_product_id],
            "limit": 1,
            "activePage": 1
        }

        await props.di.POST('amazon/request/preview', payload).then((res: any) => {
            if (res?.success) {
                setPreviewModal({ ...previewModal, open: true, loading: false, btnLoading: false })
                if (res?.data?.Mandatory) {
                    Object.keys((res?.data?.Mandatory)).forEach((key: string) => {
                        tempData['mandatory_attr'][key] = res?.data?.Mandatory?.[key]?.value
                        tempTabularData['mandatory_attr'][res?.data?.Mandatory[key]['label']] = res?.data?.Mandatory?.[key]?.value
                    })
                }
                if (res?.data?.Optional) {
                    Object.keys((res?.data?.Optional)).forEach((key: string) => {
                        tempData['optional_attr'][key] = res?.data?.Optional?.[key]?.value
                        tempTabularData['optional_attr'][res?.data?.Optional[key]['label']] = res?.data?.Optional?.[key]?.value
                    })
                }

                if (res?.data?.offerId) {
                    tempData['offerId'] = res?.data?.offerId || "";
                }
                if (res?.error && res?.error.length > 0) {
                    props?.error(t(res?.error?.[0]))

                }
                else tempData['offerId'] = "";
            }
            else {
                props?.error(t(res?.message))
                setPreviewModal({ ...previewModal, open: true, loading: false, btnLoading: false, msg: res?.message })
            }
        })
        setPreviewModalData({ ...tempData })
        setTabularData({ ...tempTabularData })
    }

    const getVariantTitle = () => {
        let optArr: any = [];
        props.di.POST('amazon/request/variantTitle', {
            ...DataToSend(props),
            "source_product_ids": [row?.source_product_id],
            "limit": 1,
            "activePage": 1
        }).then((response: any) => {
            if (response?.success) {
                let obj: any = {};
                if (Object.keys(response?.variantTitle)?.length > 0) {
                    Object.keys(response?.variantTitle)?.forEach((key: string) => {
                        if (key !== row?.source_product_id) {
                            obj = { label: response?.variantTitle?.[key], value: key }
                            optArr?.push(obj);
                        }
                    })
                }
                setVariantsArr([...optArr]);
            }
        })
    }

    const openPreviewModal = () => {
        setPreviewModal({ ...previewModal, open: true, loading: true, btnLoading: true })
        getPreview()
        getVariantTitle();
    }
    return (
        <React.Fragment>
            <Popover
                active={popoverActive}
                activator={
                    <Button
                        disabled={props?.bulkedit}
                        onClick={togglePopoverActive}
                        icon={MobileVerticalDotsMajor} />
                }
                autofocusTarget="first-node"
                onClose={togglePopoverActive}>
                <ActionList actionRole="menuitem" items={options} />
            </Popover>
            <Tooltip content={t("Amazon Preview")} dismissOnMouseOut>
                <Button onClick={() => openPreviewModal()} icon={ViewMinor} />
            </Tooltip>

            <Modal
                size='large'
                title={t("Product Preview")}
                open={previewModal.open}
                onClose={() => {
                    setPreviewModal({ ...previewModal, open: false, loading: false, btnLoading: false })
                    setSelectedVariant('')
                    setTabSelected(0)
                }}
                primaryAction={{
                    content: t('Edit Information'),
                    onAction: () => {
                        if (row?.profile && Object.keys(row?.profile).length > 0) {
                            props.history(`../config/template/${row?.['profile']?.['profile_id']?.['$oid']}`);
                        }
                        // else props.history(`.${isAdminLoggedIn() || row?.items?.[0]?.ai_updated_product ? "/new" : ""}/${row['container_id']}`, {
                        else props.history(`.${"/new"}/${row['container_id']}`, {
                            state: {
                                source_product_id: row.source_product_id ?? row.container_id ?? '',
                                status: row,
                            }
                        });
                        setPreviewModal({ ...previewModal, open: false, loading: false, btnLoading: false })
                    },
                    loading: previewModal.loading,
                }}
            // secondaryActions={isAdminLoggedIn()
            //     ? [{
            //         content: 'Edit Information AI',
            //         onAction: () => {
            //             if (row?.profile && Object.keys(row?.profile).length > 0) {
            //                 props.history(`../config/template/${row?.['profile']?.['profile_id']?.['$oid']}`);
            //             } else {
            //                 props.history(`./new/${row['container_id']}`, {
            //                     state: {
            //                         source_product_id: row.source_product_id ?? row.container_id ?? '',
            //                         status: row,
            //                     }
            //                 });
            //             }
            //             setPreviewModal({ ...previewModal, open: false, loading: false, btnLoading: false });
            //         },
            //     }]
            //     : ([] as ComplexAction[])}
            >
                <Modal.Section>
                    {
                        previewModal.loading ?
                            modalLoader() :
                            <div className='custom_tabs'>
                                {
                                    Object.keys(previewModalData.mandatory_attr).length !== 0 ?
                                        <Tabs tabs={previewModalTabs(t)} selected={tabSelected} onSelect={handleTabChange}>
                                            <BlockStack gap='500' align='start'>
                                                <Divider />
                                                <Banner tone='info'>
                                                    <Text as='p'><b>{t("NOTE:")}</b> {t("Actual product listing may vary slightly.")}</Text>
                                                </Banner>
                                                {
                                                    tabSelected === 0 ?
                                                        <AmazonPreview
                                                            previewModalData={previewModalData}
                                                            variantsArr={variantsArr}
                                                            getPreview={getPreview}
                                                            selectedVariant={selectedVariant}
                                                            setSelectedVariant={setSelectedVariant}
                                                        />
                                                        :
                                                        <TabularPreview
                                                            previewModalData={tabularData}
                                                            variantsArr={variantsArr}
                                                            getPreview={getPreview}
                                                            selectedVariant={selectedVariant}
                                                            setSelectedVariant={setSelectedVariant}
                                                        />
                                                }
                                            </BlockStack>
                                        </Tabs>
                                        :
                                        <InlineStack align="center">
                                            <EmptyState image={NoResultsFound} heading={t('No Data Found')} />
                                        </InlineStack>
                                }
                            </div>
                    }
                </Modal.Section>
            </Modal>
        </React.Fragment>
    );
};

export default DI(StatusWiseAction);